import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import randomLocalstorage from './modules/randomLocalstorage'
// import user from './modules/user'
// import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    randomLocalstorage
    // user,
    // permission
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js